__webpack_require__.hmrF = () => ("scholarships." + __webpack_require__.h() + ".hot-update.json");